import { render, staticRenderFns } from "./CardCheck.vue?vue&type=template&id=0b39b9fc&scoped=true&"
import script from "./CardCheck.vue?vue&type=script&lang=js&"
export * from "./CardCheck.vue?vue&type=script&lang=js&"
import style0 from "./CardCheck.vue?vue&type=style&index=0&id=0b39b9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b39b9fc",
  null
  
)

export default component.exports